import { ArrowRight, ArrowUpRight } from "lucide-react";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HoverImageSlider from "../home/HoverImageSlider";
import blogs from "../../assets/blogsData/blogsData";

const BlogSection = () => {
  const [displayedText, setDisplayedText] = useState("");
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [isCursorVisible, setIsCursorVisible] = useState(false);
  const [isTouch, setIsTouch] = useState(false);
  const text = "The latest blog from us.";
  const navigate = useNavigate();

  

  useEffect(() => {
    const handleTouch = () => setIsTouch(true);
    window.addEventListener("touchstart", handleTouch, { once: true });
    return () => window.removeEventListener("touchstart", handleTouch);
  }, []);

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setDisplayedText(text.slice(0, index + 1));
      index++;
      if (index === text.length) clearInterval(interval);
    }, 80);
    return () => clearInterval(interval);
  }, []);

  const handleMouseMove = (e) => {
    setCursorPos({ x: e.clientX, y: e.clientY });
  };

  

  return (
    <section className="px-4 sm:px-6 lg:px-20 py-12 sm:py-16 relative">
      {!isTouch && isCursorVisible && (
        <div
          className="fixed w-12 h-12 sm:w-16 sm:h-16 bg-blue-950 text-white rounded-full flex items-center justify-center pointer-events-none z-30 transition-transform duration-75 max-sm:hidden"
          style={{
            left: cursorPos.x - 24,
            top: cursorPos.y - 24,
          }}
        >
          <ArrowUpRight size={20} className="sm:size-7" />
        </div>
      )}

      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-6">
        <div>
          <span className="flex items-center gap-2">
            <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
            <span className="text-base sm:text-lg font-medium">
              Latest News & Blogs
            </span>
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-black leading-snug mt-2">
            {displayedText}
          </h1>
        </div>

        <button
          className="relative w-fit overflow-hidden inline-flex items-center gap-2 px-6 py-3 sm:py-4 rounded-full border border-white hover:border-black text-white hover:text-black bg-[#000d2f] hover:bg-white font-medium group transition-colors duration-300"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            navigate("/blog");
          }}
        >
          <span className="relative z-10 flex items-center gap-2">
            <span className="relative block overflow-hidden h-6">
              <span className="block transition-transform duration-300 transform group-hover:-translate-y-full">
                View All Insights
              </span>
              <span className="absolute top-full left-0 w-full block text-black transition-transform duration-300 transform group-hover:-translate-y-full">
                View All Insights
              </span>
            </span>
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
          </span>
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10 sm:mt-12">
        {blogs.slice(0, 3).map((blog) => (
          <div
            key={blog.id}
            className="group relative cursor-pointer"
            onMouseMove={!isTouch ? handleMouseMove : undefined}
            onMouseEnter={() => !isTouch && setIsCursorVisible(true)}
            onMouseLeave={() => !isTouch && setIsCursorVisible(false)}
          >
            <div className="relative rounded-xl">
              <HoverImageSlider images={blog.images} />
            </div>

            <p className="text-black text-sm font-light sm:text-base mt-4">
              {blog.time}
            </p>
            <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold mt-2">
              {blog.title}
            </h3>
            <p className="text-[#4a4f54] text-sm sm:text-base mt-1">
              {blog.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogSection;
